// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../styles/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/icons/info-i-32px.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/icons/info-i-blue-32px.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-indicator > p {
	font-family: "Inter", sens-serif;
}

.risk-indicator-container-wrap {
	margin: 0;
	margin-bottom: 0.3rem;
}

.risk-indicator-container {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	margin: 0rem;
	margin-bottom: 0.7rem;
	width: 100%;
	background-color: var(--risk-container);
	color: var(--primary-color);
	border-radius: 2rem;
	padding: 0.4rem;
	height: 3.5rem;
	cursor: default;
}

.risk-indicator-container-nodata {
	margin-bottom: 1rem;
	background-color: var(--risk-container);
	font-size: 1.2rem;
	align-self: center;
	text-align: left;
	display: flex;
	align-content: center;
	align-items: center;
}

.risk-indicator-container-nodata p {
	padding: 1rem;
	margin: 0rem 1rem;
	font-family: "Inter", sens-serif;
}

.risk-indicator-ipanel {
	font-size: 1.2rem;
	background-color: var(--risk-container);
	border-radius: 4px;
	margin-bottom: 1rem;
	padding: 1rem;
}
.risk-indicator-ipanel h1 {
	margin: 0;
	font-size: 1.4rem;
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
}
.risk-indicator-ipanel h1:first-child {
	padding-right: 24px;
}
.risk-indicator-ipanel strong {
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
}
.risk-indicator-ipanel p {
	font-size: 1.2rem;
	padding: 0.5rem 0 0.5rem 0;
}
.risk-indicator-ipanel ul {
	padding: 0.5rem 0 0.5rem 0;
}
.risk-indicator-ipanel li {
	list-style: none;
	padding: 0 0 0.5rem 1rem;
	font-family: "Inter", sens-serif;
}

.risk-indicator-mini {
	zoom: 0.85;
}
.risk-indicator-mini .risk-indicator-container {
	margin-bottom: 0;
}

.risk-indicator-container h1 {
	font-size: 1.4rem;
	align-self: center;
	margin-left: 1rem;
}

.risk-indicator-item {
	display: flex;
	background-color: var(--risk-item);
	border-radius: 2rem;
	width: 33%;
	padding: 0.3rem;
}

.risk-indicator {
	border-radius: 2rem;
}

.risk-indicator-0 {
	border-radius: 2rem;
	width: 33%;
	background-color: var(--risk-item-0);
	height: 100%;
	overflow: visible;
}

.risk-indicator-1 {
	border-radius: 2rem;
	width: 66%;
	background-color: var(--risk-item-1);
	height: 100%;
	overflow: visible;
}

.risk-indicator-2 {
	border-radius: 2rem;
	width: 100%;
	background-color: var(--risk-item-2);
	height: 100%;
	overflow: visible;
}

.risk-indicator-info {
	width: 28px;
	height: 28px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: 28px;
	background-repeat: no-repeat;
	margin-bottom: 1.6rem;
}

.risk-indicator-acc {
	width: 100%;
	font-family: "Inter-Bold";
	font-weight: bold;
	font-size: 1.6rem;
	color: white;
	align-self: center;
	text-align: center;
	display: flex;
	align-content: center;
	justify-content: center;
	align-items: center;
}

.risk-indicator-acc-0 {
	border-radius: 2rem;
	width: 33%;
	background-color: var(--acc-item-0);
	height: 100%;
	overflow: visible;
}

.risk-indicator-acc-1 {
	font-size: 2rem;
	border-radius: 2rem;
	width: 66%;
	background-color: var(--acc-item-1);
	height: 100%;
	overflow: visible;
}

.risk-indicator-acc-2 {
	border-radius: 2rem;
	width: 100%;
	background-color: var(--acc-item-2);
	height: 100%;
	overflow: visible;
}

@media (max-width: 499px) {
	.risk-indicator-container {
		background-color: var(--www-color-float-bg1);
	}
	.risk-indicator-container-nodata {
		background-color: var(--www-color-float-bg1);
	}
	.risk-indicator-item {
		background-color: var(--risk-container);
	}
	.risk-indicator-info {
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	}
	.risk-indicator-ipanel {
		background-color: var(--www-color-float-bg1);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/RiskInfo/RiskIndicator.css"],"names":[],"mappings":"AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,YAAY;CACZ,qBAAqB;CACrB,WAAW;CACX,uCAAuC;CACvC,2BAA2B;CAC3B,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,uCAAuC;CACvC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;CACjB,uCAAuC;CACvC,kBAAkB;CAClB,mBAAmB;CACnB,aAAa;AACd;AACA;CACC,SAAS;CACT,iBAAiB;CACjB,qCAAqC;CACrC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qCAAqC;CACrC,iBAAiB;AAClB;AACA;CACC,iBAAiB;CACjB,0BAA0B;AAC3B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,mBAAmB;CACnB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,oCAAoC;CACpC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,oCAAoC;CACpC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,oCAAoC;CACpC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yDAAqD;CACrD,qBAAqB;CACrB,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,mCAAmC;CACnC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC;EACC,4CAA4C;CAC7C;CACA;EACC,4CAA4C;CAC7C;CACA;EACC,uCAAuC;CACxC;CACA;EACC,yDAA0D;CAC3D;CACA;EACC,4CAA4C;CAC7C;AACD","sourcesContent":["@import url(\"styles/colors.css\");\n\n.risk-indicator > p {\n\tfont-family: \"Inter\", sens-serif;\n}\n\n.risk-indicator-container-wrap {\n\tmargin: 0;\n\tmargin-bottom: 0.3rem;\n}\n\n.risk-indicator-container {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-direction: row;\n\tmargin: 0rem;\n\tmargin-bottom: 0.7rem;\n\twidth: 100%;\n\tbackground-color: var(--risk-container);\n\tcolor: var(--primary-color);\n\tborder-radius: 2rem;\n\tpadding: 0.4rem;\n\theight: 3.5rem;\n\tcursor: default;\n}\n\n.risk-indicator-container-nodata {\n\tmargin-bottom: 1rem;\n\tbackground-color: var(--risk-container);\n\tfont-size: 1.2rem;\n\talign-self: center;\n\ttext-align: left;\n\tdisplay: flex;\n\talign-content: center;\n\talign-items: center;\n}\n\n.risk-indicator-container-nodata p {\n\tpadding: 1rem;\n\tmargin: 0rem 1rem;\n\tfont-family: \"Inter\", sens-serif;\n}\n\n.risk-indicator-ipanel {\n\tfont-size: 1.2rem;\n\tbackground-color: var(--risk-container);\n\tborder-radius: 4px;\n\tmargin-bottom: 1rem;\n\tpadding: 1rem;\n}\n.risk-indicator-ipanel h1 {\n\tmargin: 0;\n\tfont-size: 1.4rem;\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n}\n.risk-indicator-ipanel h1:first-child {\n\tpadding-right: 24px;\n}\n.risk-indicator-ipanel strong {\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n}\n.risk-indicator-ipanel p {\n\tfont-size: 1.2rem;\n\tpadding: 0.5rem 0 0.5rem 0;\n}\n.risk-indicator-ipanel ul {\n\tpadding: 0.5rem 0 0.5rem 0;\n}\n.risk-indicator-ipanel li {\n\tlist-style: none;\n\tpadding: 0 0 0.5rem 1rem;\n\tfont-family: \"Inter\", sens-serif;\n}\n\n.risk-indicator-mini {\n\tzoom: 0.85;\n}\n.risk-indicator-mini .risk-indicator-container {\n\tmargin-bottom: 0;\n}\n\n.risk-indicator-container h1 {\n\tfont-size: 1.4rem;\n\talign-self: center;\n\tmargin-left: 1rem;\n}\n\n.risk-indicator-item {\n\tdisplay: flex;\n\tbackground-color: var(--risk-item);\n\tborder-radius: 2rem;\n\twidth: 33%;\n\tpadding: 0.3rem;\n}\n\n.risk-indicator {\n\tborder-radius: 2rem;\n}\n\n.risk-indicator-0 {\n\tborder-radius: 2rem;\n\twidth: 33%;\n\tbackground-color: var(--risk-item-0);\n\theight: 100%;\n\toverflow: visible;\n}\n\n.risk-indicator-1 {\n\tborder-radius: 2rem;\n\twidth: 66%;\n\tbackground-color: var(--risk-item-1);\n\theight: 100%;\n\toverflow: visible;\n}\n\n.risk-indicator-2 {\n\tborder-radius: 2rem;\n\twidth: 100%;\n\tbackground-color: var(--risk-item-2);\n\theight: 100%;\n\toverflow: visible;\n}\n\n.risk-indicator-info {\n\twidth: 28px;\n\theight: 28px;\n\tbackground-image: url(\"assets/icons/info-i-32px.png\");\n\tbackground-size: 28px;\n\tbackground-repeat: no-repeat;\n\tmargin-bottom: 1.6rem;\n}\n\n.risk-indicator-acc {\n\twidth: 100%;\n\tfont-family: \"Inter-Bold\";\n\tfont-weight: bold;\n\tfont-size: 1.6rem;\n\tcolor: white;\n\talign-self: center;\n\ttext-align: center;\n\tdisplay: flex;\n\talign-content: center;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.risk-indicator-acc-0 {\n\tborder-radius: 2rem;\n\twidth: 33%;\n\tbackground-color: var(--acc-item-0);\n\theight: 100%;\n\toverflow: visible;\n}\n\n.risk-indicator-acc-1 {\n\tfont-size: 2rem;\n\tborder-radius: 2rem;\n\twidth: 66%;\n\tbackground-color: var(--acc-item-1);\n\theight: 100%;\n\toverflow: visible;\n}\n\n.risk-indicator-acc-2 {\n\tborder-radius: 2rem;\n\twidth: 100%;\n\tbackground-color: var(--acc-item-2);\n\theight: 100%;\n\toverflow: visible;\n}\n\n@media (max-width: 499px) {\n\t.risk-indicator-container {\n\t\tbackground-color: var(--www-color-float-bg1);\n\t}\n\t.risk-indicator-container-nodata {\n\t\tbackground-color: var(--www-color-float-bg1);\n\t}\n\t.risk-indicator-item {\n\t\tbackground-color: var(--risk-container);\n\t}\n\t.risk-indicator-info {\n\t\tbackground-image: url(\"assets/icons/info-i-blue-32px.png\");\n\t}\n\t.risk-indicator-ipanel {\n\t\tbackground-color: var(--www-color-float-bg1);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
